import Login from 'pages/Login';
import Register from 'pages/Register';
import Profile from 'pages/Profile';
import HomePage from 'pages/HomePage';
import Dashboard from 'pages/Dashboard';
import UpdatePassword from 'pages/UpdatePassword';
import ForgotPassword from 'pages/ForgotPassword';
import SearchResult from  'pages/SearchResult';
// import LandingPage from 'pages/LandingPage';
import CatalogPage from 'pages/Catalog';
import NavigationPage from 'pages/NavigationPage';
import FollowingPage from 'pages/Following'

const routes = [

    {
        path: '/',
        exact: true,
        component: HomePage,
        isProtected: false

    },
    {
        path: '/login',
        exact: true,
        component: Login,
        isProtected: false

    },
    {
        path: '/register',
        exact: true,
        component: Register,
        isProtected: false

    },
    {
        path: '/forgot-password',
        exact: true,
        component: ForgotPassword,
        isProtected: false
    },
    {
        path: '/reset/:key',
        exact: true,
        component: UpdatePassword,
        isProtected: false
    },
    {
        path: '/user',
        exact: false,
        component: NavigationPage,
        isProtected: true
    }

];

const protectedRoutes = [

    {
        path: '/profile',
        exact: false,
        WrappedComponent: Profile,
        isProtected: true,
        isSearch: false

    },
    {
        path: '/dashboard',
        exact: true,
        WrappedComponent: Dashboard,
        isProtected: true,
        isSearch: false

    },
    
    {
        path: '/search-result',
        exact: true,
        WrappedComponent: SearchResult,
        isProtected: true,
        isSearch: true

    },
    {
        path: '/landing',
        exact: false,
        // WrappedComponent: LandingPage,
        WrappedComponent: FollowingPage,
        isProtected: true,
        isSearch: false

    },
    {
        path: '/catalog',
        exact: true,
        WrappedComponent: CatalogPage,
        isProtected: true,
        isSearch: false

    }
]
export {protectedRoutes} ;

export default routes;